export type EvidenceTagKind = "NORMATIVO" | "EVIDENCIA" | "DISEÑO" | "SIMULADO" | "POR VERIFICAR";

export const EVIDENCE_TAGS: readonly EvidenceTagKind[] = [
  "NORMATIVO",
  "EVIDENCIA",
  "DISEÑO",
  "SIMULADO",
  "POR VERIFICAR",
] as const;

export const EVIDENCE_TAG_LABELS: Record<EvidenceTagKind, string> = {
  NORMATIVO: "Normativo",
  EVIDENCIA: "Evidencia",
  DISEÑO: "Diseño",
  SIMULADO: "Simulado",
  "POR VERIFICAR": "Por verificar",
};
